<template>
  <div class="user-panel">
    <div class="user-info">
      <div class="image-container">
        <div class="user-image" />
      </div>
      <div v-if="!isXSmall" class="user-name">{{ currentUser }}</div>
    </div>

    <dx-context-menu
      v-if="menuMode === 'context'"
      target=".user-button"
      :items="menuItems"
      :width="172"
      show-event="dxclick"
      css-class="user-menu gc-user-panel"
      item-template="item"
    >
      <template #item="{ data }">
        <div>
          <span v-if="data.icon" :class="'dx-icon dx-icon-' + data.icon"></span>
          <span :style="{ marginLeft: 5 }">{{ data.text }}</span>
        </div>
      </template>
      <template #separator>
        <div class="gc-separator"></div>
      </template>
      <dx-position my="top center" at="bottom center" />
    </dx-context-menu>

    <dx-list
      v-if="menuMode === 'list'"
      class="dx-toolbar-menu-action"
      :items="menuItems"
    />
  </div>
</template>

<script>
import DxContextMenu, { DxPosition } from "devextreme-vue/context-menu";
import DxList from "devextreme-vue/list";
import { authComputed } from "../_store/helpers";

export default {
  props: {
    menuMode: String,
    menuItems: Array,
    isXSmall: Boolean,
  },
  computed: {
    ...authComputed,
  },
  created() {
    // eslint-disable-next-line no-console
    // this.$logger.debug("Menu Mode", this.menuMode);
  },

  components: {
    DxContextMenu,
    DxPosition,
    DxList,
  },
};
</script>

<style lang="scss">
@import "../assets/styles/variables.base.scss";

.user-info {
  display: flex;
  align-items: center;

  .dx-toolbar-menu-section & {
    padding: 10px 6px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .image-container {
    overflow: hidden;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    margin: 0 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);

    .user-image {
      width: 100%;
      height: 100%;
      background: url("../assets/images/no-profile.png") no-repeat #fff;
      background-size: cover;
    }
  }

  .user-name {
    font-size: 14px;
    color: $base-text-color;
    margin: 0 9px;
  }
}

.user-panel {
  .dx-list-item .dx-icon {
    vertical-align: middle;
    color: $base-text-color;
    margin-right: 16px;
  }
  .dx-rtl .dx-list-item .dx-icon {
    margin-right: 0;
    margin-left: 16px;
  }
}

.dx-context-menu.user-menu.dx-menu-base {
  &.dx-rtl {
    .dx-submenu .dx-menu-items-container .dx-icon {
      margin-left: 16px;
    }
  }
  .dx-submenu .dx-menu-items-container .dx-icon {
    margin-right: 16px;
  }
  .dx-menu-item .dx-menu-item-content {
    padding: 3px 15px 4px;
  }
}

.dx-theme-generic .user-menu .dx-menu-item-content .dx-menu-item-text {
  padding-left: 4px;
  padding-right: 4px;
}

.gc-separator {
  border-top: 1px rgb(224, 224, 224) solid;
  padding: 0px;
}

.gc-user-panel {
  .dx-menu-item {
    .dx-menu-item-content {
      display: flex;
      align-items: center;
    }
  }
}
</style>
